// Body.js
import React from 'react';
import {Container} from 'react-bootstrap';
import {Outlet} from 'react-router-dom';

export const Body = () => {
  return (
    <Container className='text-light mt-5 mb-5'>
      <Outlet />
    </Container>
  );
}
